import { vsosHttp as http } from 'lib/services/http';

/**
 * VSOS Swagger for Hunt Groups available at
 * http://10.103.50.156:8080/swagger-ui.html#/Hunt-Groups
 */

const deleteHuntGroups = ({ huntGroupId, teamId }) => {
  return http.delete('/hunt-groups', {
    params: { huntGroupId, teamId },
  });
};

const getCallFlowCountForTeam = (teamId: string) => {
  return http.get('/hunt-groups/call-flows', {
    params: { teamId },
  });
};

const getCallForwardAlways = (huntGroup: string) => {
  return http.get(`/hunt-groups/${huntGroup}/call-forwarding-always`);
};

const getCallForwardBusy = (huntGroup: string) => {
  return http.get(`/hunt-groups/${huntGroup}/call-forwarding-busy`);
};

const getCallForwardSelective = (huntGroup: string) => {
  return http.get(`/hunt-groups/${huntGroup}/call-forwarding-selective`);
};

const getCallForwardUnanswered = (huntGroup: string) => {
  return http.get(`/hunt-groups/${huntGroup}/call-forwarding-unanswered`);
};

const getHuntGroupAvailableNumbers = (huntGroup: string) => {
  return http.get(`/hunt-groups/${huntGroup}/phone-number`);
};

const getHuntGroupCallDistro = (profileId: string) => {
  return http.get(`/hunt-groups/${profileId}/call-distribution`);
};

const putHuntGroupCallDistro = (profileId: string, requestBody) => {
  return http.put(`/hunt-groups/${profileId}/call-distribution`, requestBody);
};

const toggleCallForwardAlwaysActive = (huntGroup: string, enabled = false) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-always/active`, {
    enabled,
  });
};

const toggleCallForwardBusyActive = (huntGroup: string, enabled = false) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-busy/active`, {
    enabled,
  });
};

const toggleCallForwardSelectiveActive = (
  huntGroup: string,
  enabled = false,
) => {
  return http.put(
    `/hunt-groups/${huntGroup}/call-forwarding-selective/active`,
    {
      enabled,
    },
  );
};

const updateCallForwardAlways = (huntGroup: string, body) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-always`, body);
};

const updateCallForwardBusy = (huntGroup: string, body) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-busy`, body);
};

const updateCallForwardSelective = (huntGroup: string, body) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-selective`, body);
};

const updateCallForwardUnanswered = (huntGroup: string, body) => {
  return http.put(`/hunt-groups/${huntGroup}/call-forwarding-unanswered`, body);
};

const updateHuntGroupPhoneNumber = (
  huntGroup: string,
  body,
  locationId: string,
) => {
  return http.put(
    `/hunt-groups/${huntGroup}/phone-number?locationId=${locationId}`,
    body,
  );
};

export default {
  deleteHuntGroups,
  getCallFlowCountForTeam,
  getCallForwardAlways,
  getCallForwardBusy,
  getCallForwardSelective,
  getCallForwardUnanswered,
  getHuntGroupAvailableNumbers,
  getHuntGroupCallDistro,
  putHuntGroupCallDistro,
  toggleCallForwardAlwaysActive,
  toggleCallForwardBusyActive,
  toggleCallForwardSelectiveActive,
  updateCallForwardAlways,
  updateCallForwardBusy,
  updateCallForwardSelective,
  updateCallForwardUnanswered,
  updateHuntGroupPhoneNumber,
};
